import React from 'react';
import Button from 'carbon-react/lib/components/button';

import { FormattedMessage } from '@futrli/localisation';

import { PopoverMenu } from '@futrli/ui-components/components/popover-menu/popover-menu';

import * as styles from './schedule-review-popover.scss';

interface ScheduleReviewPopoverProps {
  onApprove: () => void;
  onDeny: () => void;
  disabled?: boolean;
  isHidden?: boolean;
}

export const ScheduleReviewPopover = ({ onApprove, onDeny, disabled, isHidden = false }: ScheduleReviewPopoverProps) => {
  return (
    <div className={isHidden ? styles.hiddenAction : undefined} aria-hidden={isHidden}>
      <PopoverMenu
        items={[
          {
            label: <FormattedMessage id="reporting.approve_and_send" defaultMessage="Approve and send" />,
            onClick: onApprove
          },
          {
            label: <FormattedMessage id="reporting.cancel_send" defaultMessage="Cancel send" />,
            onClick: onDeny
          }
        ]}
        renderOpenComponent={({ onClick, ref, 'aria-expanded': ariaExpanded }) => (
          <Button
            buttonType="secondary"
            iconType="caret_down"
            iconPosition="after"
            disabled={disabled}
            onClick={onClick}
            ref={ref}
            aria-expanded={ariaExpanded}
          >
            <FormattedMessage id="predict.review" defaultMessage="Review" />
          </Button>
        )}
      />
    </div>
  );
};
